<template>
  <div class="flex-col">
    <a-tooltip v-for="(amount, key) of row.insured_amounts" :key="key">
      <template #title>{{ key }}</template>
      {{ amount }}
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: "InsuredAmounts",
  props: {
    row: {
      insured_amounts: {
        type: Object,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>